const env = import.meta.env.MODE || 'development';
const isDevelopment = import.meta.env.DEV;

const stripTrailingSlash = (url) => (url || '').replace(/\/$/, '');
const toWebSocketUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('wss://') || url.startsWith('ws://')) return stripTrailingSlash(url);
  if (url.startsWith('https://')) return stripTrailingSlash(url.replace(/^https:\/\//, 'wss://'));
  if (url.startsWith('http://')) return stripTrailingSlash(url.replace(/^http:\/\//, 'ws://'));
  return stripTrailingSlash(url);
};

const productionApiBase = stripTrailingSlash(
  import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_REACT_APP_API_URL
);
const productionClientUrl = stripTrailingSlash(import.meta.env.VITE_CLIENT_URL);
const productionWebSocketUrl = toWebSocketUrl(
  import.meta.env.VITE_WEBSOCKET_URL || productionApiBase
);

// Government API endpoints (MyInvois Malaysia)
const GOV_API_ENDPOINTS = {
  TOKEN: '/irb/taxpayer-token',
  INTERMEDIARY_TOKEN: '/irb/intermediary-token',
  DOCUMENTS_SUBMISSIONS: '/irb/documentsubmissions',
  VALIDATE_TIN: '/irb/validate-tin',
  NOTIFICATIONS: '/irb/notifications',
  DOCUMENTS_RECENT: '/v1.0/documents/recent',
  DOCUMENTS_SEARCH: '/v1.0/documents/search',
  DOCUMENT_DETAILS: '/irb/submitted-document-details',
  INVOICE_FORM_DATA: '/irb/invoice-form-data',
  DOCUMENTS_STATE: '/v1.0/documents/state',
  DOCUMENTS_RAW: '/v1.0/documents'
};

// Application URLs
const APP_URLS = {
  development: {
    // Use /api prefix for all API requests - Vite proxy will forward to backend
    // This ensures cookies are properly forwarded with withCredentials
    API_BASE: '/api', 
    CLIENT_URL: import.meta.env.VITE_CLIENT_URL || 'http://localhost:5173',
    WEBSOCKET_URL: import.meta.env.VITE_WEBSOCKET_URL || 'ws://localhost:5000'
  },
  production: {
    API_BASE: productionApiBase,
    CLIENT_URL: productionClientUrl,
    WEBSOCKET_URL: productionWebSocketUrl
  }
};

const currentAppUrls = APP_URLS[env] || APP_URLS.development;
export { getMyInvoisShareBase } from './myInvoisUrls';

// Helper functions for building URLs
export const buildApiUrl = (endpoint, params = {}) => {
  let url = endpoint;
  if (params.uuid) url = url.replace(':uuid', params.uuid);
  if (params.tin) url = url.replace(':tin', params.tin);
  return url;
};

// Get API URL helper for WebSocket and other uses
export const getApiUrl = () => {
  return currentAppUrls.API_BASE || '/api';
};

// Export configuration
export {
  GOV_API_ENDPOINTS,
  APP_URLS,
  currentAppUrls,
  isDevelopment,
  env as ENVIRONMENT
};
